export default __webpack_public_path__ + "static/media/INCIDENTS-request.1cb70754.png";